<template>
	<div>
		<el-row :gutter="30">
			<el-col class="box" :span="24">
				<div class="list__header">
					<p class="list__title">
						{{ getRouteName($route) }}
					</p>
          <div>
            <search-list-form v-model="filters.selected.search" @submit="fetchData"/>
              <el-button size="small" title="Oznacz jako opłacone" @click="downloadCSV">
              <i class="fa fa-download"> Export CSV</i>
            </el-button>
          </div>
				</div>
				<el-table :data="data"
						  highlight-current-row
						  v-loading="listLoading"
						  class="list__table"
						  style="width: 100%;">
					<el-table-column prop="id" label="Id" width="80"></el-table-column>
					<el-table-column prop="lounger.type_display" label="Typ"></el-table-column>
          <el-table-column prop="lounger.date" label="Data"></el-table-column>
          <el-table-column prop="price_display" label="Cena (zł)"></el-table-column>
          <el-table-column prop="buyer.first_name" label="Imię"></el-table-column>
          <el-table-column prop="buyer.last_name" label="Nazwisko"></el-table-column>
          <el-table-column prop="buyer.phone" label="Telefon"></el-table-column>
          <el-table-column prop="buyer.email" label="Email"></el-table-column>
          <el-table-column prop="payment_status" label="Status płatności"></el-table-column>
          <el-table-column label="opcje" width="150" class="pull-right">
            <template slot-scope="scope" class="pull-right">
              <el-button size="small" title="Oznacz jako opłacone" @click="mark_as_paid(scope.row.id)">
                <i class="fa fa-check"> Opłacone</i>
              </el-button>
            </template>
          </el-table-column>
				</el-table>
			</el-col>
		</el-row>
	</div>
</template>
<script>
	import { LoungerReservation } from '@/api/';
  import axios from "axios";

	export default {
		data () {
			return {
				data: [],
        filters: {
          available: [],
          selected: {}
        },
				listLoading: false,
				service: LoungerReservation
			}
		},
		methods: {
			fetchData () {
				this.listLoading = true;
        let params = {
          ...this.filters.selected
        }
				this.service.fetch({}, { params }).then(response => {
					this.data = response.data;
					this.listLoading = false;
				})
			},
			async handleDelete (index, row) {
				await this.$confirm(this.$i18n.t('deleteConfirmation'), this.$i18n.t('delete'), {
					type: 'warning'
				})

				this.listLoading = true;
				await this.service.delete(row.id)

				this.listLoading = false;
				this.$message({
					message: 'Element został usunięty',
					type: 'success'
				})

				this.fetchData()
			},
      mark_as_paid (id) {
			  this.service.mark_as_paid(id).then(response => {
			    this.fetchData()
        })
      },
      downloadCSV () {
        const url = this.service.exportUrl()
        axios({
          url: url,
          method: 'GET',
          responseType: 'blob', // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `rezerwacje_leżaków.csv`)
          document.body.appendChild(link)
          link.click()
        })
      },
		},
		mounted () {
			this.fetchData()
		}
	}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// ReservationList.vue?a1daa47c